/* LL 88P: partition existing merchant HTML without rewriting any wording. */
(() => {
  if (customElements.get('ll-manual-details')) return;
  customElements.define('ll-manual-details', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller, source = this.querySelector('[data-details-source]'), host = this.querySelector('[data-details-enhanced]');
      if (!source || !host) return;
      const markers = [...source.querySelectorAll('strong,b,h3,h4,em')].map(element => {
        const text = element.textContent.trim().toLowerCase();
        if (/^allergens?\b/.test(text)) return { element, type: 'allergens' };
        if (/^warnings?\b/.test(text) || (element.matches('em') && /allerg|facility|caution|warning/.test(text))) return { element, type: 'warnings' };
        if (/^ingredients?\b/.test(text)) return { element, type: 'ingredients' };
        return null;
      }).filter(Boolean);
      const points = [{ element: null, type: 'ingredients' }, ...markers];
      const fragments = new Map([['ingredients', []], ['allergens', []], ['warnings', []]]);
      points.forEach((point, index) => {
        const range = document.createRange();
        if (point.element) range.setStartBefore(point.element); else range.setStart(source, 0);
        const next = points[index + 1];
        if (next?.element) range.setEndBefore(next.element); else range.setEnd(source, source.childNodes.length);
        const wrapper = document.createElement('div'); wrapper.append(range.cloneContents());
        if (wrapper.textContent.trim()) fragments.get(point.type).push(wrapper.innerHTML);
      });
      const sections = [['ingredients', 'Ingredients'], ['allergens', 'Allergens'], ['warnings', 'Warnings']]
        .filter(([type]) => fragments.get(type).length);
      if (!sections.length) return;
      const tabs = document.createElement('div'); tabs.className = 'll-manual-details__tabs'; tabs.role = 'tablist'; tabs.setAttribute('aria-label', 'Ingredients, allergens and warnings');
      const panels = [];
      sections.forEach(([type, label], index) => {
        const safe = `${this.dataset.id}-${type}`.replace(/[^a-zA-Z0-9_-]/g, '-');
        const button = document.createElement('button'); button.type = 'button'; button.role = 'tab'; button.id = `ll-manual-${safe}-tab`; button.setAttribute('aria-controls', `ll-manual-${safe}`); button.setAttribute('aria-selected', String(index === 0)); button.tabIndex = index === 0 ? 0 : -1; button.textContent = label;
        const panel = document.createElement('div'); panel.id = `ll-manual-${safe}`; panel.className = 'll-manual-details__panel rte remove-empty-space'; panel.role = 'tabpanel'; panel.tabIndex = 0; panel.setAttribute('aria-labelledby', button.id); panel.hidden = index !== 0; panel.innerHTML = fragments.get(type).join('');
        tabs.append(button); panels.push(panel);
      });
      const select = button => {
        [...tabs.children].forEach(tab => { const active = tab === button; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
        panels.forEach(panel => { panel.hidden = panel.id !== button.getAttribute('aria-controls'); });
      };
      tabs.addEventListener('click', event => { const button = event.target.closest('[role="tab"]'); if (button) select(button); }, { signal });
      tabs.addEventListener('keydown', event => {
        const buttons = [...tabs.children], index = buttons.indexOf(event.target); if (index < 0) return;
        let next; if (event.key === 'ArrowRight') next = (index + 1) % buttons.length; if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length; if (event.key === 'Home') next = 0; if (event.key === 'End') next = buttons.length - 1; if (next === undefined) return;
        event.preventDefault(); buttons[next].focus(); select(buttons[next]);
      }, { signal });
      host.replaceChildren(tabs, ...panels); host.hidden = false; source.hidden = true;
      const productRoot = this.closest('[data-js-product-component]');
      const pairs = productRoot ? [...productRoot.querySelectorAll('[data-manual-nutrition-choice]')].filter(pair => pair.dataset.manualNutritionChoice.trim()) : [];
      if (pairs.length > 1) {
        const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
          .replace(/\bthousand\b/g, '1000').replace(/\bchili\b/g, 'chilli').replace(/\bsauce\b/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
        const syncChoice = () => {
          const selected = [...productRoot.querySelectorAll('product-variants input:checked,product-variants select')].map(input => normalize(input.value)).filter(Boolean);
          const match = pairs.find(pair => {
            const label = normalize(pair.dataset.manualNutritionChoice);
            return selected.some(value => label && (label.includes(value) || value.includes(label)));
          });
          pairs.forEach(pair => { pair.hidden = Boolean(match && pair !== match); });
        };
        productRoot.addEventListener('change', event => { if (event.target.closest('product-variants')) syncChoice(); }, { signal });
        queueMicrotask(syncChoice);
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
})();
